enum ProductDeliveryStatus {
    Success = 'SUCCESS',
    Error = 'ERROR',
}

export default ProductDeliveryStatus;
